import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-6 text-center">
      <h1 className="font-heading text-6xl md:text-8xl font-bold text-primary-500">404</h1>
      <p className="text-lg text-foreground-600 mt-4">The page you are looking for does not exist.</p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
      >
        <i className="ri-arrow-left-line"></i>
        Back to Homepage
      </Link>
    </div>
  );
}